import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Tone } from '../../Shape2/Shape2';

import './PhrasesSelectorStartWordActions.css';

export interface PhrasesSelectorStartWordAction {
    icon: Shape2Icon;
    text: string;
    handler: () => void;
}

export interface PhrasesSelectorStartWordActionsProps {
    actions: Array<PhrasesSelectorStartWordAction>;
}

const BLOCK = 'phrases-selector-start-word-actions';

export const PhrasesSelectorStartWordActions = ({ actions }: PhrasesSelectorStartWordActionsProps) => (
    <div className={Bem.cls(BLOCK)}>
        <ul className={Bem.cls(BLOCK, 'list')}>
            {actions.map(action => (
                <li key={action.text} className={Bem.cls(BLOCK, 'item')} onClick={action.handler}>
                    <Shape2
                        tone={Shape2Tone.white}
                        width={16}
                        height={16}
                        icon={action.icon}
                        cls={Bem.cls(BLOCK, 'action-icon')}
                    />
                    {action.text}
                </li>
            ))}
        </ul>
    </div>
);
